import { Background } from "../../../features/api/apiSlice";

interface BackgroundRendererProps {
  background: Background;
  videoClassName?: string;
  imageClassName?: string;
}

export const BackgroundRenderer: React.FC<BackgroundRendererProps> = ({
  background,
  videoClassName,
  imageClassName
}) => {
  if (background.type === "none") {
    return null;
  }

  if (background.type === "video") {
    return (
      <video
        playsInline
        autoPlay
        muted
        loop
        src={background.url}
        className={videoClassName}
      />
    );
  }

  return (
    <img
      src={background.url}
      alt={background.type}
      className={imageClassName}
    />
  );
};